import { call, put, fork, take } from 'redux-saga/effects';
import axios from 'axios';

import { REQUEST } from 'redux-config/reduxHelpers';
import {
  GET_CRM_FINANCES_DEPOSITS,
  getCrmFinancesDeposits,
  GET_CRM_FINANCES_WITHDRAWALS,
  getCrmFinancesWithdrawals,
  GET_CRM_FINANCES_TRANSFERS,
  getCrmFinancesTransfers,
  GET_CRM_FINANCES_PAYMENT_SYSTEMS,
  getCrmFinancesPaymentSystems,
} from './actions';

function* getDepositsSaga(search) {
  try {
    const { data } = yield call(() => axios.get('/crm/finances/deposit/', { params: { ...search } }));
    yield put(getCrmFinancesDeposits.success(data));
  } catch (error) {
    yield put(getCrmFinancesDeposits.failure(error));
  }
}

function* getDepositsWatcherSaga() {
  while (true) {
    const { search } = yield take(GET_CRM_FINANCES_DEPOSITS[REQUEST]);
    yield call(getDepositsSaga, search);
  }
}

function* getWithdrawalsSaga(search) {
  try {
    const { data } = yield call(() => axios.get('/crm/finances/withdraw/', { params: { ...search } }));
    yield put(getCrmFinancesWithdrawals.success(data));
  } catch (error) {
    yield put(getCrmFinancesWithdrawals.failure(error));
  }
}

function* getWithdrawalsWatcherSaga() {
  while (true) {
    const { search } = yield take(GET_CRM_FINANCES_WITHDRAWALS[REQUEST]);
    yield call(getWithdrawalsSaga, search);
  }
}

function* getTransfersSaga(search) {
  try {
    const { data } = yield call(() => axios.get('/crm/finances/internal_transfers/', { params: { ...search } }));
    yield put(getCrmFinancesTransfers.success(data));
  } catch (error) {
    yield put(getCrmFinancesTransfers.failure(error));
  }
}

function* getTransfersWatcherSaga() {
  while (true) {
    const { search } = yield take(GET_CRM_FINANCES_TRANSFERS[REQUEST]);
    yield call(getTransfersSaga, search);
  }
}

function* getPaymentSystemsSaga() {
  try {
    const { data } = yield call(() => axios.get('/payments/v2/payment_system/slugs/'));
    yield put(getCrmFinancesPaymentSystems.success(data));
  } catch (error) {
    yield put(getCrmFinancesPaymentSystems.failure(error));
  }
}

function* getPaymentSystemsWatcherSaga() {
  while (true) {
    yield take(GET_CRM_FINANCES_PAYMENT_SYSTEMS[REQUEST]);
    yield call(getPaymentSystemsSaga);
  }
}

export default [
  fork(getDepositsWatcherSaga),
  fork(getWithdrawalsWatcherSaga),
  fork(getTransfersWatcherSaga),
  fork(getPaymentSystemsWatcherSaga),
];
